module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"EPSG:2056":"CH 1903+","EPSG:32632":"SCR UTM Nord Zone 32","no-coordinate":"Aucune coordonnée"},"de":{}}')
  delete Component.options._Ctor
}
